import { Create } from 'react-admin';
import BillerMerchantCodeForm from './BillerMerchantCodeForm';

const BillerMerchantCodeCreate = () => {
  return (
    <Create>
      <BillerMerchantCodeForm />
    </Create>
  );
};

export default BillerMerchantCodeCreate;
